import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { hasAnyPermission, hasPermission } from "../utils/permissions";

import Loader from '../components/Loader';

const PrivateRoute = ({ children, permission }) => {
    const { user, token, loading } = useContext(AuthContext);
    const location = useLocation();

    if (loading) { return <Loader />; }

    if (!user || !token) { return <Navigate to="/login" replace state={{ from: location }} />; }

    const allowed = Array.isArray(permission)
        ? hasAnyPermission(user, permission)
        : hasPermission(user, permission);

    if (permission && !allowed) {
        return (
            <div className="container-fluid flex-grow-1 container-p-y">
                <section className="section-card text-center py-5">
                    <div className="empty-state-icon mx-auto mb-3">
                        <i className="bx bx-lock-alt"></i>
                    </div>
                    <h4>Acces non autorise</h4>
                    <p className="text-muted mb-0">Votre profil ne dispose pas encore de l'autorisation pour cette page.</p>
                </section>
            </div>
        );
    }

    return children;
};

export default PrivateRoute;
